import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from 'vue'
import { ImagePreview } from 'vant'


export default /*@__PURE__*/_defineComponent({
  __name: 'ImgPreview',
  props: {
    previewShow: { type: Boolean },
    previewIndex: {},
    imageList: {},
    showIndex: { type: Boolean }
  },
  emits: ['closePreview'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const currentIndex = ref(props.previewIndex || 0)
const show = ref(props.previewShow)
const emits = __emit

const extractImageUrls = (imageList: string[]) => {
  const extractedUrls = imageList.map((url) => {
    // 使用正则表达式来提取问号前面的地址
    const match = url.match(/^(.*?)(\?|$)/)
    if (match) {
      return match[1]
    }
    return url
  })
  return extractedUrls
}

watch(
  () => [props.previewShow, props.previewIndex],
  (newVal) => {
    if (newVal[0]) {
      show.value = newVal[0] as boolean
    }
    if (newVal[1]) {
      currentIndex.value = newVal[1] as number
    }
  },
  { immediate: true }
)
const onClose = () => {
  emits('closePreview', false)
}

const onChange = (newIndex: number) => {
  currentIndex.value = newIndex
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ImagePreview), {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    images: extractImageUrls(_ctx.imageList),
    startPosition: _ctx.previewIndex,
    showIndex: _ctx.showIndex,
    loop: false,
    onChange: onChange,
    onClose: onClose,
    overlayStyle: { background: 'rgba(0,0,0,0.75)' }
  }, {
    index: _withCtx(() => [
      _createTextVNode(_toDisplayString(currentIndex.value + 1 + '/' + _ctx.imageList.length), 1)
    ]),
    _: 1
  }, 8, ["show", "images", "startPosition", "showIndex"]))
}
}

})